import { render } from "./subheader.vue?vue&type=template&id=65116b9d"
import script from "./subheader.vue?vue&type=script&lang=js"
export * from "./subheader.vue?vue&type=script&lang=js"

import "./subheader.vue?vue&type=style&index=0&id=65116b9d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
